import { HooksService } from '@shoppykey/hook';
import BaseApp from './base-app';

export const apps: (new () => BaseApp)[] = [];

export function registerApps(hooksService: HooksService) {
  apps.forEach((App) => {
    hooksService.registerHookActions(new App());
  });
}
